// NPM Imports
import React from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// JS Imports
//@ts-ignore
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports
//@ts-ignore
import { MonthlyPrice } from '../../../common/types/calculate'
import { Button } from 'react-bootstrap'

function ConsultingServicesRow() {
   //TODO: change this to the proper typing once we migrate App.jsx to Typescript
   const state = useQuoteContext()
   const { getString } = state
   const permissions = state.featurePermissions['ConsultingServices']

   function onAddService() {
      const updatedList = [
         ...state.consultingServiceDetails,
         { serviceCode: 'None', count: 0 },
      ]
      state.setConsultingServiceDetails(updatedList)
   }

   if (permissions?.includes(state.user_role)) {
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {getString('product.ConsultingServicesRow.ProductName')}
            </div>
            <div className='col-bhr2'>
               <Button
                  size='sm'
                  className='add-remove-item-btn'
                  onClick={onAddService}
               >
                  {getString('product.ConsultingServicesRow.Button')}
               </Button>
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.ConsultingServicesCosts.reduce(
                     (acc: number, val: MonthlyPrice) => acc + val.totalPrice,
                     0,
                  ),
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )
   }

   return null
}

export default ConsultingServicesRow
